import { API_PREFIX } from "./api.constants";

export const NOTIFICATION_ENDPOINTS = {
  LIST: `${API_PREFIX}/notifications`,
  UNREAD_COUNT: `${API_PREFIX}/notifications/unread-count`,
  MARK_READ: (id: number | string) => `${API_PREFIX}/notifications/${id}/read`,
  MARK_ALL_READ: `${API_PREFIX}/notifications/read-all`,

  // Admin: centralized templates
  TEMPLATES: `${API_PREFIX}/notification-templates`,
  TEMPLATE: (key: string) => `${API_PREFIX}/notification-templates/${key}`,
  TEMPLATE_RESET: (key: string) => `${API_PREFIX}/notification-templates/${key}/reset`,

  // Course-scoped overrides
  TEMPLATE_COURSE: (courseId: number | string, key: string) =>
    `${API_PREFIX}/notification-templates/course/${courseId}/${key}`,
  TEMPLATE_COURSE_RESET: (courseId: number | string, key: string) =>
    `${API_PREFIX}/notification-templates/course/${courseId}/${key}/reset`,

  // Program-scoped overrides (learning_path_* / certification_* events of one program)
  TEMPLATES_PROGRAM: (pathId: number | string) =>
    `${API_PREFIX}/notification-templates/program/${pathId}`,
  TEMPLATE_PROGRAM: (pathId: number | string, key: string) =>
    `${API_PREFIX}/notification-templates/program/${pathId}/${key}`,
  TEMPLATE_PROGRAM_RESET: (pathId: number | string, key: string) =>
    `${API_PREFIX}/notification-templates/program/${pathId}/${key}/reset`,

  // Seminar-scoped overrides (cseminar_* events of one seminar)
  TEMPLATES_SEMINAR: (seminarId: number | string) =>
    `${API_PREFIX}/notification-templates/seminar/${seminarId}`,
  TEMPLATE_SEMINAR: (seminarId: number | string, key: string) =>
    `${API_PREFIX}/notification-templates/seminar/${seminarId}/${key}`,
  TEMPLATE_SEMINAR_RESET: (seminarId: number | string, key: string) =>
    `${API_PREFIX}/notification-templates/seminar/${seminarId}/${key}/reset`,
};
